import { render, staticRenderFns } from "./XPBadge.vue?vue&type=template&id=25d015de&scoped=true&"
import script from "./XPBadge.vue?vue&type=script&lang=ts&"
export * from "./XPBadge.vue?vue&type=script&lang=ts&"
import style0 from "./XPBadge.vue?vue&type=style&index=0&id=25d015de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d015de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25d015de', component.options)
    } else {
      api.reload('25d015de', component.options)
    }
    module.hot.accept("./XPBadge.vue?vue&type=template&id=25d015de&scoped=true&", function () {
      api.rerender('25d015de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/XPBadge.vue"
export default component.exports